import { Typography } from "@material-tailwind/react";

export default function Footer() {
  return (
    <footer className="w-full bg-[#1a1a1a] text-white py-8 md:py-10 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        {/* Top Footer Layout */}
        <div className="flex flex-col lg:flex-row justify-between items-center lg:items-start gap-6 md:gap-8">
          {/* Rights Reserved */}
          <div className="order-2 lg:order-1 text-center lg:text-left w-full lg:w-auto">
            <Typography
              variant="h2"
              className="text-3xl sm:text-4xl font-bold text-white"
            >
              DTU
            </Typography>
            <Typography className="text-gray-400 text-base sm:text-lg">
              &copy; {new Date().getFullYear()} Delhi Technological University
            </Typography>
            <Typography className="text-gray-500 text-sm sm:text-md mt-1">
              All rights reserved
            </Typography>
          </div>

          {/* DTU Logo - Centered - Add your logo here if needed */}
          <div className="order-1 lg:order-2"></div>

          {/* Quick Links */}
          <div className="order-3 text-center lg:text-right space-y-2 w-full lg:w-auto">
            <Typography
              variant="h6"
              className="text-lg sm:text-xl font-semibold text-white"
            >
              Quick Links
            </Typography>
            <ul className="grid grid-cols-2 sm:grid-cols-4 lg:flex lg:flex-col gap-2 sm:gap-1 justify-items-center lg:justify-items-end">
              {[
                {
                  label: "About Us",
                  href: "https://www.dtu.ac.in/Web/About/history.php",
                },
                {
                  label: "Administration",
                  href: "https://www.dtu.ac.in/Web/Administrations/Chancellor.php",
                },
                {
                  label: "Admissions",
                  href: "https://dtu.ac.in/Web/dtujac.php",
                },
                { label: "Contact Us", href: "/contact-us" },
              ].map(({ label, href }) => (
                <li key={label} className="lg:ml-4">
                  <Typography
                    as="a"
                    href={href}
                    className="text-gray-400 hover:text-white transition-colors text-xs sm:text-sm"
                  >
                    {label}
                  </Typography>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <hr className="my-6 sm:my-8 border-gray-700" />

        {/* Developed By Section */}
        <div className="text-center">
          <Typography
            variant="h6"
            className="text-lg sm:text-xl font-semibold text-gray-300 mb-2 sm:mb-4"
          >
            DEVELOPED BY
          </Typography>

          <div className="flex flex-col items-center space-y-2 sm:space-y-3">
            {/* Mentor */}
            <div className="mb-2 sm:mb-3">
              <a
                href="https://www.linkedin.com/in/sumit-khandelwal-aaa6b5103/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Typography className="text-gray-300 hover:text-white transition-colors text-xs sm:text-sm font-medium">
                  Sumit Kumar Khandelwal
                </Typography>
              </a>
              <Typography className="text-gray-400 text-xs italic">
                Mentor
              </Typography>
            </div>

            {/* Developers */}
            <div className="flex flex-wrap justify-center gap-2 sm:gap-4">
              {[
                {
                  name: "Divyansh Bansal",
                  linkedin:
                    "https://www.linkedin.com/in/divyansh-bansal-873610229/",
                },
                {
                  name: "Divyansh Sinha",
                  linkedin:
                    "https://www.linkedin.com/in/divyansh-sinha-aa8026226/",
                },
                {
                  name: "Divyanshu Sinha",
                  linkedin:
                    "https://www.linkedin.com/in/divyanshu-sinha-57a8aa24b/",
                },
              ].map((person, index) => (
                <a
                  key={index}
                  href={person.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-1 sm:px-0"
                >
                  <Typography className="text-gray-300 hover:text-white transition-colors text-xs sm:text-sm font-medium">
                    {person.name}
                  </Typography>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
